<script>
    import { Navigate, Route } from 'svelte-router-spa';
    
    export let currentRoute;
  </script>
  
  <h1>Your name is: {currentRoute.name} {currentRoute.queryParams['waitlist']}</h1>
  <p>

  </p>
  